export default __webpack_public_path__ + "static/media/PEFI.8a401a81.png";